import React, { useEffect, useState } from "react";
import "./Our_Presence.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { FaMapMarkerAlt } from "react-icons/fa";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Locations } from "../../../utils/apis/homepage";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const Our_Presence = () => {
  // const cities = [
  //   "Ratnagiri",
  //   "Sangameshwar",
  //   "Chiplun",
  //   "Khed",
  //   "Dapoli",
  //   "Guhagar",
  //   "Rajapur",
  //   "Lanja",
  //   "Mahad",
  //   "Sawantwadi",
  // ];

  // const locations = [
  //   { name: "Ratnagiri", lat: 16.9903, lng: 73.3120 },
  //   { name: "Sangameshwar", lat: 17.1858, lng: 73.5517 },
  //   { name: "Chiplun", lat: 17.5333, lng: 73.5167 },
  //   { name: "Khed", lat: 17.7170, lng: 73.3960 },
  //   { name: "Dapoli", lat: 17.7580, lng: 73.1856 },
  //   { name: "Guhagar", lat: 17.4747, lng: 73.1936 },
  //   { name: "Rajapur", lat: 16.6567, lng: 73.5178 },
  //   { name: "Lanja", lat: 16.8620, lng: 73.5490 },
  //   { name: "Mahad", lat: 18.0820, lng: 73.4225 },
  //   { name: "Sawantwadi", lat: 15.9050, lng: 73.8213 },
  // ];

  const locations = [
    { name: "", lat: 17.0593767004062, lng: 73.63139111084759 },
    { name: "", lat: 16.989162279760134, lng: 73.32293155600934 },
    { name: "", lat: 16.884564230968966, lng: 73.35720145087113 },
    { name: "", lat: 16.953094041364587, lng: 73.3024438202332 },
    { name: "", lat: 16.98800548035692, lng: 73.36919904273508 },
    { name: "", lat: 17.140043815618625, lng: 73.56161564464016 },
    { name: "", lat: 16.99339718007177, lng: 73.30619217600534 },
    { name: "", lat: 17.006249581802773, lng: 73.33262927269202 },
    { name: "", lat: 16.990424675361545, lng: 73.37274641315611 },
    { name: "", lat: 17.519637171176953, lng: 73.5462762673317 },
    { name: "", lat: 16.99331706642946, lng: 73.28724273016601 },
    { name: "", lat: 16.995643321375823, lng: 73.30669051288366 },
    { name: "", lat: 17.146745280694045, lng: 73.54907816159744 },
    { name: "", lat: 16.950640574356928, lng: 73.29740587810412 },
    { name: "", lat: 16.99615006412014, lng: 73.30894981398451 },
    { name: "", lat: 16.988787402571457, lng: 73.33380853761193 },
    { name: "", lat: 16.98740250016743, lng: 73.32798652956996 },
    { name: "", lat: 16.89277926413382, lng: 73.31372146715208 },
    { name: "", lat: 17.140237184803407, lng: 73.56206421805977 },
    { name: "", lat: 17.002584309190908, lng: 73.37138552892965 },
    { name: "", lat: 17.009493588673628, lng: 73.34858263454592 },
    { name: "", lat: 16.997470596489336, lng: 73.31075513690246 },
    { name: "", lat: 17.73878641789849, lng: 73.31825153281976 },
    { name: "", lat: 17.00414945622999, lng: 73.36813104496184 },
    { name: "", lat: 17.532633949373025, lng: 73.52210839079555 },
    { name: "", lat: 16.997432345880256, lng: 73.36948022630561 },
    { name: "", lat: 17.059773348355137, lng: 73.63003845361818 },
    { name: "", lat: 17.173761951263536, lng: 73.53316180664541 },
    { name: "", lat: 17.005962502277722, lng: 73.37295485328683 },
    { name: "", lat: 16.98898674687248, lng: 73.33701762086984 },
    { name: "", lat: 16.995059793773706, lng: 73.29493022379161 },
    { name: "", lat: 16.998498448246437, lng: 73.2938236853883 },
    { name: "", lat: 16.994456810441285, lng: 73.30995907766489 },
    { name: "", lat: 16.996103865426416, lng: 73.31659354802792 },
    { name: "", lat: 16.99015094834427, lng: 73.31944692030983 },
    { name: "", lat: 17.515465053421433, lng: 73.54557903143417 },
    { name: "", lat: 17.003138180206186, lng: 73.36942647731243 },
    { name: "", lat: 16.957911171477047, lng: 73.42526677795101 },
    { name: "", lat: 16.984988865288276, lng: 73.30200829692576 },
    { name: "", lat: 17.483031421281, lng: 73.53369999317968 },
    { name: "", lat: 16.985800279907153, lng: 73.32049027600968 },
    { name: "", lat: 16.994564876940505, lng: 73.27810183746497 },
    { name: "", lat: 17.062734595503436, lng: 73.62193273944764 },
    { name: "", lat: 16.989826039731195, lng: 73.34410383692486 },
    { name: "", lat: 17.417227417559655, lng: 73.53639277920752 },
    { name: "", lat: 16.99840167410788, lng: 73.31429330190775 },
    { name: "", lat: 16.998003609752413, lng: 73.3133063989989 },
    { name: "", lat: 16.991042344683006, lng: 73.31366805499958 },
    { name: "", lat: 16.996162994784886, lng: 73.35478408255825 },
    { name: "", lat: 17.015261252467113, lng: 73.37990495503772 },
  ];

  const [location, setLocation] = useState([]);

  const getLocation = async () => {
    const res = await Locations();

    console.log("API RESPONSE:", res);

    if (res?.success) {
      setLocation(res.data);
    }
  };

  useEffect(() => {
    getLocation();
  }, []);

  const mapSrc = `https://maps.google.com/maps?q=${location?.lat},${location?.long}&z=15&output=embed`;

  console.log("MAP URL:", mapSrc);

  return (
    <section className="Our_Presence">
      <div className="Our_Presence_title_holder">
        <h5 className="Our_Presence_title">Our Growing Presence</h5>
        <p className="Our_Presence_text">
          Delivering trusted solar solutions across multiple cities, regions,
          and communities in India.
        </p>
      </div>

      {/* Swiper */}

      {/* <div className="presence_swiper">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={5}
          loop={true}
          freeMode={true}
          speed={4000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
          }}
          breakpoints={{
            320: { slidesPerView: 2 },
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
            1200: { slidesPerView: 5 },
            1400: { slidesPerView: 6 },
          }}
          className="marquee_swiper"
        >
          {cities.map((city, index) => (
            <SwiperSlide key={index}>
              <div className="city_card">
                <FaMapMarkerAlt className="location_icon" />
                <span>{city}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div> */}

      <div className="container">
        <MapContainer
          center={[16.9902, 73.312]} // Ratnagiri center
          zoom={7}
          className="mapsection"
        >
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {location.map((loc, index) => (
            <Marker key={index} position={[Number(loc.lat), Number(loc.long)]}>
              <Popup>
                <div>
                  <p>{loc?.address}</p>
                  <p>{loc?.kilo_watt}</p>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </section>
  );
};

export default Our_Presence;
